import {Archive, BookText, ChevronRight, ShieldCheck, Users} from "lucide-react";
import {Link} from "react-router";

const sections = [
    {
        title: "Kampagnen",
        description: "Kampagnen anlegen, bearbeiten und löschen.",
        to: "/admin/campaigns",
        icon: BookText,
        available: true,
    },
    {
        title: "Backups",
        description: "Sicherungen erstellen, herunterladen, wiederherstellen und löschen.",
        to: "/admin/backups",
        icon: Archive,
        available: true,
    },
    {
        title: "Benutzer",
        description: "Benutzer und Berechtigungen verwalten.",
        to: "/admin/users",
        icon: Users,
        available: true,
    },
];

export default function AdminOverviewView() {
    return <main className="p-6">
        <title>Administration | DireDawn</title>
        <div className="mx-auto max-w-5xl space-y-6">
            <div>
                <p className="mb-2 text-xs font-semibold uppercase tracking-[0.22em] text-primary">System</p>
                <h1 className="flex items-center gap-2 text-3xl font-semibold tracking-tight"><ShieldCheck className="text-secondary-foreground"/>Administration</h1>
                <p className="mt-1 text-muted-foreground">Globale Einstellungen und Daten unabhängig von einer Kampagne verwalten.</p>
            </div>
            <div className="grid gap-4 md:grid-cols-2">
                {sections.map(section => section.available
                    ? <Link key={section.title} to={section.to}
                          className="group flex items-center gap-4 rounded-xl border border-border/80 bg-card/90 p-5 shadow-lg shadow-black/10 transition-all hover:-translate-y-0.5 hover:border-secondary/60 hover:shadow-secondary/10">
                        <section.icon className="size-8 text-secondary-foreground"/>
                        <div className="grow">
                            <h2 className="font-medium">{section.title}</h2>
                            <p className="mt-1 text-sm text-muted-foreground">{section.description}</p>
                        </div>
                        <ChevronRight className="size-5 transition-transform group-hover:translate-x-1"/>
                    </Link>
                    : <div key={section.title} className="flex items-center gap-4 rounded-xl border bg-card/50 p-5 opacity-60">
                        <section.icon className="size-8"/>
                        <div>
                            <div className="flex items-center gap-2"><h2 className="font-medium">{section.title}</h2><span className="text-xs text-muted-foreground">Später</span></div>
                            <p className="mt-1 text-sm text-muted-foreground">{section.description}</p>
                        </div>
                    </div>)}
            </div>
        </div>
    </main>;
}
